/************************************************************************************************************
 * We need the configuration BEFORE the MSAL module loads in order to initialize the library with client id,
 * tenantt, ... A common way to proceed is to use APP_INITIALIZER that should complete BEFORE any imported
 * module is loaded.
 * However that might not work, hence loading the config  before bootstrapping the application.
 * The config is then made available via a custom injection token (see APP_CONFIG definition).
 ***********************************************************************************************************/


import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_CONFIG, CONFIG_LOCATION } from './app/core/services/app-config.service';
import { AugmentConsole } from 'src/app/shared/utils/utils-global';
import { ApiConfig, AppConfig } from './app/shared/models/config-variable.model';
import { env } from 'process';

// AugmentConsole add the new logEx, errorEx, .... methods to the global console object
AugmentConsole();

console.logEx( "*** Main module reloaded *****************")

fetch( CONFIG_LOCATION ) //('/assets/config.json')
  .then((response) => response.json())
  .then((configFromJson) => {
    if (environment.production) {
      enableProdMode()
    }

	// copy configFromJson values into config in order to benefit AppConfig methods and properties
	// that are actually not available in  configFromJson
	let config:AppConfig=new AppConfig( location.hostname );
	Object.assign( config, configFromJson);

	platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err))
  })
